import ng from 'angular';
import angular from 'angular';
import moment from 'moment';
import { IAnexo } from '../../../../Anexos/models/anexo.model';
import { TipoSolicitacaoEnum } from '../../../../../../shared/enums/TipoSolicitacaoEnum';
import { TiposDocumentosRequeridosService } from '../../../../../Tiposdocumentosrequeridos/tiposdocumentosrequeridos.service';
import {
    contaBancoValida,
    getMensagemContaBanco,
    digitoVerificadorContaValido,
    getMensagemDigitoVerificador,
    TipoPagamentoEnum
} from '../../../../../../utils/dados-bancarios';
import { TipoContaPixEnum } from '../../../../../../shared/enums/TipoContaPixEnum';

export class MeurhAdmissoesestagiarioDependentesFormmodalController implements ng.IController {

    static $inject = [
        '$scope',
        '$element',
        '$attrs',
        'NewToaster',
        '$rootScope',
        '$sce',
        'TiposDocumentosRequeridosService',
        'MeurhAdmissaoestagiarioModalService'
    ];

    public dependente: any;
    public action: string;
    public uFArray = [
        'AC', 'AL', 'AM', 'AP', 'BA',
        'CE', 'DF', 'ES', 'GO', 'MA',
        'MG', 'MS', 'MT', 'PA', 'PB',
        'PE', 'PI', 'PR', 'RJ', 'RN',
        'RO', 'RR', 'RS', 'SC', 'SE',
        'SP', 'TO'
    ];
    public form: angular.IFormController;
    public constructor_: any = {};
    public tiporecebimentoHabilitado: boolean = false;
    public objadmissao: any;
    public tiposdocumentosrequeridosdependentes: Array<any> = [];
    public busyTipoDocumentos: boolean = false;
    public busyAnexo: boolean = false;
    public editanexo: boolean = true;
    public entityAnexo: IAnexo = {};
    public actionAnexo: string = 'insert';

    // inicio - tratamento de datas
    public anoMinimo: moment.Moment;
    // fim - tratamento de datas

    public exibeAlertaConta: boolean = false;
    public focoInputConta: boolean = false;

    public exibeAlertaDigitoVerificador: boolean = false;
    public focoInputDigitoVerificador: boolean = false;

    public tiposPagamentoChecaDv = [
        TipoPagamentoEnum.CONTA_CORRENTE,
        TipoPagamentoEnum.CONTA_POUPANCA,
        TipoPagamentoEnum.CONTA_SALARIO,
        TipoPagamentoEnum.PIX_AGENCIA_CONTA
    ];

    public tipoContaPixEnum = TipoContaPixEnum;

    constructor(
        public $scope: angular.IScope,
        public $element: any,
        public $attrs: any,
        public NewToaster: any,
        public $rootScope: angular.IRootScopeService & { configuracoes: any, session: any },
        public $sce: angular.ISCEService,
        private TiposDocumentosRequeridosService: TiposDocumentosRequeridosService,
    ) {
        $scope.$watch('$ctrl.dependente.cpf', (newValue?: string, oldValue?: string) => {
			if (newValue !== oldValue) {
                const isCpfDoColaborador = newValue === this.objadmissao?.cpf;
                const isCpfUtilizado =
                    this.objadmissao?.dependentes &&
                    Array.isArray(this.objadmissao.dependentes) &&
                    this.objadmissao.dependentes.some(dependente => (
                        dependente.cpf === newValue &&
                        dependente.counter !== this.dependente.counter
                    ));

                this.form.cpf.$setValidity('cpfUsado', !(isCpfDoColaborador || isCpfUtilizado));
			}
		}, true);
    }

    $onInit(): void {
        this.bloqueiaAnoMinimo();
        this.constructor_ = this.verificacaoBanco();
        this.inicializaDocumentosAnexos();

        if (this.dependente.matricula === undefined) {
            this.dependente.matricula = ' ';
        }
        if (this.valorExiste(this.dependente.nome)) {
            this.dependente.parentesco = this.dependente.parentesco ? this.dependente.parentesco.toString() : this.dependente.parentesco;
            this.dependente.sexo = this.dependente.sexo ? this.dependente.sexo.toString() : this.dependente.sexo;
            this.dependente.tiporecebimento = this.dependente.tiporecebimento ? this.dependente.tiporecebimento.toString() : this.dependente.tiporecebimento;
            this.dependente.tipocontapix = this.dependente.tipocontapix ? this.dependente.tipocontapix.toString() : this.dependente.tipocontapix;
            this.calculaIdade();
        } else if (this.objadmissao) {
            this.dependente.datainclusao = this.objadmissao.dataadmissao;
        }

        if (this.action === 'edit') {

            // se tipo de pagamento pode exibir alertas na conta e DV
            if (this.tiposPagamentoChecaDv.includes(this.dependente.tiporecebimento as TipoPagamentoEnum)) {
                this.validaContaPagamento();
                this.validaDigitoVerificadorConta();
            }

            this.verificaBeneficiariopensaoalimenticia();

        }

    }

    calculaIdade(): void {
        if (this.valorExiste(this.dependente.datanascimento)) {
            this.dependente['idade'] = moment().diff(this.dependente.datanascimento, 'years');
        }
    }

    preencheCampo(): void {

        if (this.dependente.tiporecebimento !== '64') {
            this.dependente.tipocontapix = null;
        }

        if (this.dependente.tiporecebimento === '128') { // cpf
            this.dependente.chavepix = this.dependente.cpf;
        } else {
            this.dependente.chavepix = '';
        }
    }

    preenchePix(): void {
        if (this.dependente.tiporecebimento === '128') { // cpf
            this.dependente.chavepix = this.dependente.cpf;
        }
    }

    verificaBeneficiariopensaoalimenticia(): void {
        if (this.dependente.pensaoalimenticia === true) {
            this.tiporecebimentoHabilitado = true;
        } else {
            this.dependente.tiporecebimento = '';
            this.tiporecebimentoHabilitado = false;

        }
    }

    verificacaoBanco(): { banco: string | null } {
        if (this.dependente.banco) {
            if (this.dependente.banco.banco) {
                return { 'banco': this.dependente.banco.banco };
            }
        }
        return { 'banco': null };
    }

    public vencimentoEscolarObrigatorio(): boolean {
        return (
            (this.dependente.idade !== undefined && this.dependente.idade !== null) &&
            (this.dependente.idade >= 7 && this.dependente.idade <= 14) &&
            this.dependente.salariofamilia &&
            !this.dependente.incapacidadefisicamental
        );
    }

    public vencimentoVacinacaoObrigatorio(): boolean {
        return (
            (this.dependente.idade !== undefined && this.dependente.idade !== null) &&
            (this.dependente.idade < 7 || this.dependente.idade > 14) &&
            this.dependente.salariofamilia &&
            !this.dependente.incapacidadefisicamental
        );
    }

    alteraAgenciaPorBanco(): void {
        if (this.dependente.banco) {
            this.$rootScope.$broadcast('agencia_refresh', { banco: this.dependente.banco.banco });
            this.dependente.agencia = null;
        }
    }

    changeBanco(): void {
        this.limpaDadosAgenciaConta();
        this.alteraAgenciaPorBanco();
        this.constructor_ = this.verificacaoBanco();
    }

    public limpaDadosAgenciaConta() {
        this.dependente.agencia = null;
        this.dependente.numeroconta = null;
        this.dependente.numerocontadv = null;
    }

    public limpaBanco() {
        this.dependente.banco = null;
    }

    public validaContaPagamento() {
        if (!this.dependente.banco || !this.dependente.tiporecebimento || !this.dependente.numeroconta) {
            this.exibeAlertaConta = false;
            return;
        }

        this.exibeAlertaConta = !contaBancoValida(this.dependente.banco, String(this.dependente.tiporecebimento), this.dependente.numeroconta, String(this.dependente.tipocontapix)) &&
            !this.form.numeroconta?.$error?.required &&
            this.action !== 'show';
    }

    public verificaExibicaoAlertaConta() {
        if (!this.dependente.banco || !this.dependente.tiporecebimento || !this.dependente.numeroconta) {
            return false;
        }

        return !this.focoInputConta && this.exibeAlertaConta;
    }

    public getMensagemAlertaConta(): string {
        return getMensagemContaBanco(this.dependente.banco, String(this.dependente.tiporecebimento), this.dependente.numeroconta, String(this.dependente.tipocontapix));
    }

    public validaDigitoVerificadorConta() {
        if (!this.dependente.banco || !this.dependente.tiporecebimento || !this.dependente.numerocontadv) {
            this.exibeAlertaDigitoVerificador = false;
            return;
        }

        this.exibeAlertaDigitoVerificador = !digitoVerificadorContaValido(this.dependente.banco, String(this.dependente.tiporecebimento), this.dependente.numerocontadv, String(this.dependente.tipocontapix)) &&
            !this.form.numerocontadv?.$error?.required &&
            this.action !== 'show';
    }

    public verificaExibicaoAlertaDigitoVerificador() {
        if (!this.dependente.banco || !this.dependente.tiporecebimento || !this.dependente.numerocontadv) {
            return false;
        }

        return !this.focoInputDigitoVerificador && this.exibeAlertaDigitoVerificador;
    }

    public getMensagemAlertaDigitoVerificador(): string {
        return getMensagemDigitoVerificador(this.dependente.banco, String(this.dependente.tiporecebimento), this.dependente.numerocontadv, String(this.dependente.tipocontapix));
    }

    valorExiste(valor: any) {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }

    public limpaIncapacidadeFisicaMental(): void {
        if (this.dependente.parentesco?.toString() !== '3') {
            this.dependente.incapacidadefisicamental = false;
        }
    }

    public limpaCamposSalFamiliaComIncapacidadeFisicaMental(): void {
        if (!this.dependente.incapacidadefisicamental) {
            this.dependente.atestadoparanaofrequentarescola = false;
        }
    }

    public validaDocumentosAnexos(): boolean {
        return this.tiposdocumentosrequeridosdependentes.every((tipodocumentorequerido) => {
            return tipodocumentorequerido.fileSelecionado === tipodocumentorequerido.obrigatorio ||
                tipodocumentorequerido.fileSelecionado ||
                !!tipodocumentorequerido.file;
        });
    }

    private inicializaDocumentosAnexos(): void {
        this.garanteGuidDependente();
        this.actionAnexo = this.objadmissao?.solicitacao ? (this.action === 'edit' ? 'update' : (this.action || 'insert')) : 'insert';
        this.editanexo = this.action !== 'show';
        this.configuraEntityAnexo();
        this.carregaTiposDocumentosRequeridos();
    }

    private garanteGuidDependente(): void {
        if (!this.dependente.dependenteadmissaocompleta) {
            this.dependente.dependenteadmissaocompleta = this.gerarGuid();
        }
    }

    private configuraEntityAnexo(): void {
        this.entityAnexo = {
            casodeuso: 'ADMISSOESESTAGIARIO',
            solicitacao: this.objadmissao?.solicitacao,
            estabelecimento: this.getEstabelecimento(),
            tiposubentidade: 1,
            idsubentidade: this.dependente.dependenteadmissaocompleta
        };
    }

    private carregaTiposDocumentosRequeridos(): void {
        const estabelecimento = this.getEstabelecimento();

        if (!estabelecimento) {
            this.tiposdocumentosrequeridosdependentes = this.recuperaDocumentosSelecionados([]);
            this.dependente.tiposdocumentosrequeridosdependentes = this.tiposdocumentosrequeridosdependentes;
            return;
        }

        this.busyTipoDocumentos = true;
        this.dependente.busyTipoDocumentosDependente = true;

        this.TiposDocumentosRequeridosService.loadByConstructors({
            tiposolicitacao: TipoSolicitacaoEnum.INCLUSAODEPENDENTE,
            estabelecimento
        })
            .then((documentosCarregados: Array<any>) => {
                this.tiposdocumentosrequeridosdependentes = this.recuperaDocumentosSelecionados(documentosCarregados || []);
                this.dependente.tiposdocumentosrequeridosdependentes = this.tiposdocumentosrequeridosdependentes;
            })
            .catch(() => {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Não foi possível carregar os documentos requeridos do dependente'
                });
            })
            .finally(() => {
                this.busyTipoDocumentos = false;
                this.dependente.busyTipoDocumentosDependente = false;
            });
    }

    private recuperaDocumentosSelecionados(documentosCarregados: Array<any>): Array<any> {
        const documentosSelecionados = this.dependente.tiposdocumentosrequeridosdependentes || [];

        return documentosCarregados.map((tipodocumentorequerido) => {
            const tipodocumentocolaborador = tipodocumentorequerido.tipodocumentocolaborador?.tipodocumentocolaborador;
            const documentoSelecionado = documentosSelecionados.find((documento: any) => {
                return documento.tipodocumentocolaborador?.tipodocumentocolaborador === tipodocumentocolaborador;
            });

            return angular.extend({}, tipodocumentorequerido, {
                validateResult: documentoSelecionado?.validateResult || false,
                fileSelecionado: documentoSelecionado?.fileSelecionado || false,
                file: documentoSelecionado?.file || null,
                arquivoRemovido: documentoSelecionado?.arquivoRemovido || null
            });
        });
    }

    private getEstabelecimento(): string | null {
        if (this.objadmissao?.estabelecimento?.estabelecimento) {
            return this.objadmissao.estabelecimento.estabelecimento;
        }

        if (typeof this.objadmissao?.estabelecimento === 'string') {
            return this.objadmissao.estabelecimento;
        }

        return (this.$rootScope as any).estabelecimentoSelecionado || null;
    }

    private gerarGuid(): string {
        const cryptoObj = window.crypto || (window as any).msCrypto;

        if (cryptoObj && cryptoObj.getRandomValues) {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char: string) => {
                const random = cryptoObj.getRandomValues(new Uint8Array(1))[0] % 16;
                const value = char === 'x' ? random : (random % 4) + 8;
                return value.toString(16);
            });
        }

        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char: string) => {
            const random = Math.floor(Math.random() * 16);
            const value = char === 'x' ? random : (random % 4) + 8;
            return value.toString(16);
        });
    }
    // inicio - tratamento de datas
    private bloqueiaAnoMinimo(): void {
        this.anoMinimo = moment().subtract(120, 'years'); // > 120 anos
    }
    // fim - tratamento de datas
}
